// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26x4Z","label":"styles_label__1leu3"};